'use strict';

/**
 * Stage
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.Stage = T.createModule({

	_selectors: {
		slides: '[data-js-m-stage__slide]',
		images: '[data-js-a-image__img]'
	},

	_eventNames: {
		button: 'slide-button',
		interval: 'slide-interval',
		autoplay: 'slide-autoplay'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);
		this.$slides = this.$ctx.find(this._selectors.slides);
		this.$images = this.$ctx.find(this._selectors.images);

		$(window).on('scroll', this.onScroll.bind(this));

		if (this.$slides.length < 2) {
			// Only one slide that is permanently shown
			this.$slides.show();
			return resolve();
		}

		this.$currentSlideIndex = Math.floor(Math.random() * this.$slides.length);
		this.fadeInMilliseconds = this.$ctx.data('fade');
		this.intervalInSeconds = this.$ctx.data('interval');

		this._events.on(this._eventNames.button, this.onSlideIndex.bind(this));
		this._events.on(this._eventNames.autoplay, this.onChangeAutoplay.bind(this));
		this._events.on('t.sync', this.sync.bind(this));

		this.$slides.slice(this.$currentSlideIndex, this.$currentSlideIndex + 1).show();

		resolve();
	},
	sync: function sync() {
		// To slider-button's
		this._events.emit(this._eventNames.interval, this.$currentSlideIndex);

		this.interval = 0;
		this.setSliderInterval();
		this.initializeSwipe();
	},
	initializeSwipe: function initializeSwipe() {
		var _this = this;

		this.$images.swipe({
			swipeRight: function swipeRight() {
				return _this.onSwipeRight();
			},
			swipeLeft: function swipeLeft() {
				return _this.onSwipeLeft();
			},
			threshold: 50,
			// workaround for https://github.com/mattbryson/TouchSwipe-Jquery-Plugin/issues/275#issuecomment-166594275
			preventDefaultEvents: false
		});
	},


	/**
  * Use setTimeout instead of setInteval to cause follow issue: https://jira.namics.com/browse/RUAGWEB-895
  * Not able to reproduce the issue, so it is not proved that this works.
  * @returns {undefined} void
  */
	setSliderInterval: function setSliderInterval() {
		this.interval = setTimeout(this.nextSlide.bind(this), this.intervalInSeconds * 1000);
	},
	onSlideIndex: function onSlideIndex(index) {
		// eslint-disable-next-line
		clearInterval(this.interval);
		this.$currentSlideIndex = index;
		this.updateSlide();
	},
	onChangeAutoplay: function onChangeAutoplay(enableAutplay) {
		if (enableAutplay) {
			this.interval = setTimeout(this.nextSlide.bind(this), this.intervalInSeconds * 1000);
		} else {
			clearInterval(this.interval);
		}
	},
	onSwipeLeft: function onSwipeLeft() {
		clearInterval(this.interval);
		this.nextSlide();
	},
	onSwipeRight: function onSwipeRight() {
		clearInterval(this.interval);
		this.previousSlide();
	},
	onScroll: function onScroll() {
		var scrollTop = $(window).scrollTop();
		this.$ctx.css('top', scrollTop / 3 + 'px');
	},
	updateSlide: function updateSlide() {
		this.$slides.fadeOut(this.fadeInMilliseconds);
		this.$slides.slice(this.$currentSlideIndex, this.$currentSlideIndex + 1).fadeIn(this.fadeInMilliseconds);
	},
	previousSlide: function previousSlide() {
		if (--this.$currentSlideIndex === -1) {
			this.$currentSlideIndex = this.$slides.length - 1;
		}
		this._events.emit(this._eventNames.interval, this.$currentSlideIndex);
		this.updateSlide();
	},
	nextSlide: function nextSlide() {
		if (++this.$currentSlideIndex > this.$slides.length - 1) {
			this.$currentSlideIndex = 0;
		}
		this._events.emit(this._eventNames.interval, this.$currentSlideIndex);
		this.updateSlide();
		this.setSliderInterval();
	}
});